import API from "../../../store/api";
import { getAllDocuments } from './getAllDocuments';
import { clearMessage, setMessage } from '../../../store/actions/dialogActions';
import { setNotifications } from '../../../store/actions/notificationActions';
import { clearDocuments } from '../../../store/actions/documentActions';
import { authLogout } from '../../../store/actions/authActions';

export const updateDocument = (id, data, bearerAuth, formFunction, user) => {
  return async dispatch => {

    dispatch(setMessage({ type: 'LOAD' }))

    API.put(`/api/portal/document/${id}`)
      .set('Authorization', `Bearer ${bearerAuth}`)
      .send({ ...data, user: user })
      .ok(res => res.status === 200 || res.status === 401)
      .then((response) => {
        if (response.status === 200) {
          dispatch(clearMessage)
          dispatch(getAllDocuments(bearerAuth))
          dispatch(setNotifications({
            type: 'success',
            message: 'Successfully updated.'
          }))
          formFunction();
        } else if (response.status === 401) {
          dispatch(clearDocuments);
          dispatch(authLogout);
        }
      }).catch((error) => {
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
            if (message.includes(',')) { //Password error, make it more presentable
              let messageArray = message.split(',');
              message = <>{messageArray.map((val) => <div>{val}</div>)}</>
            }
          }
        }
        dispatch(setMessage({
          title: 'Update Document Failed',
          message: message,
          type: 'ERR',
        }))
      })
  }
}